<template>
    <div class="content">
        <h2>发票</h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="发票:" prop="fapiao">
                        <el-upload
                            class="upload-demo"
                            drag              :before-remove="handleRemove"          
                            action="#"  :before-upload="beforeUpload"
                            multiple :file-list="fileList">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        </el-upload>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type="warning" size="small" @click="submitFp">上传发票</el-button>
                        <el-button type="primary" size="small" @click="submit('form')">生成</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    name: "Layout",
    props:['code'],
    data() {
        return {
            loading:false,
            form:{},
            rules:{
                fapiao:[
                    { required: true, message: '发票不能为空', trigger: ['change','blur'] }
                ]
            },
            fileList: [],
            fileName:'',
            files:{},
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        this.getList()
    },
    methods: {
        async getList(){
            
        },
        beforeUpload(file){
            this.files = file;
            // const extension = file.name.split('.')[1] === 'pdf'
            // const isLt2M = file.size / 1024 / 1024 < 5
            // if (!extension) {
            // this.$message.warning('上传模板只能是 pdf格式!')
            // return
            // }else{
                if(file){
                    let isy = this.fileList.some(item => {
                        return item.name == file.name
                    })
                    if(!isy){
                        this.fileList.push({name:file.name}) 
                    }
                }
            // }
            // if (!isLt2M) {
            // this.$message.warning('上传模板大小不能超过 5MB!')
            // return
            // }
            this.fileName = file.name;
            return false // 返回false不会自动上传
        }, 
        handleRemove(file, fileList) {
            if(file.status == 'success'){
                if(this.fileList.length > 1){
                    let isy = this.fileList.findIndex(item => {
                        return item.name == file.name
                    })
                    if(isy != -1){
                        this.fileList.splice(isy,1) 
                    }
                }
            }
        },
        async submitFp(){
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的文件！')
                return false
            }
            let fileFormData = new FormData();
            fileFormData.append('file', this.files);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            fileFormData.append('fileName', this.fileName);
            let config = {
                headers: {
                'Content-Type': 'multipart/form-data'
                },
            }
            this.$axios.post(`https://xxswj.hzxhykj.com:9086/login/uploadXcFile2`,fileFormData, config)
            .then(res => {
                if(res.data.code == 0){
                    this.sbFile = res.data.filenewname[0].newFileName
                }
            }).catch(err => {
                this.$message({
                    message: '上传失败，请重新选择',
                    type: 'error'
                });
            })	
		},
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    this.$confirm("您是否确定保存当前页面数据并生成文书?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        that.$emit('handleBack',1)
                    })
                }
            })
        },
        getWh(){},
        getNr(){}
    }
}
</script>


<style scoped>
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>